import { render, staticRenderFns } from "./Type6.vue?vue&type=template&id=85af73b2&scoped=true"
import script from "./Type6.vue?vue&type=script&lang=js"
export * from "./Type6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af73b2",
  null
  
)

export default component.exports